import { ERequestStatus } from '../../types/requestStatus';
import { TCpdRegionsState } from '../../types/cpdRegions';
import { EGetCpdRegionsActionType, TCpdRegionsActions } from '../../actions/cpdRegions';

export const defaultState: TCpdRegionsState = {
  status: ERequestStatus.Initial,
  items: [],
};

export const cpdRegionsReducer = (state = defaultState, action: TCpdRegionsActions) => {
  switch (action.type) {
    case EGetCpdRegionsActionType.Succeed:
      return { ...state, ...action.payload, status: ERequestStatus.Succeed };

    default:
      return state;
  }
};
